import { faFilter, faUpload } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { ButtonGroup, Col, Container, Row, ToggleButton } from "react-bootstrap";
import { textFilter } from "react-bootstrap-table2-filter";
import Button from "react-bootstrap/Button";
import { withTranslation } from "react-i18next";
import PaginationTable from "../../../../components/paginationTable/PaginationTable";
import APIErrorHelper from "../../../../helpers/APIErrorHelper";
import CamplaCoreService from "../../../../services/CamplaCoreService";
import StorageService from "../../../../services/StorageService";
import DeletePackageDialog from "./dialogs/deletePackageDialog/DeletePackageDialog";
import PackagesActionCell from "./packagesActionCell/PackagesActionCell";
import "./PackagesTab.css";
import UploadFileDialog from "./uploadFileDialog/UploadFileDialog";

class PackagesTab extends React.Component {
  tableId = "packagesTabTable";
  constructor(props) {
    super(props);
    let showFilters = StorageService.getTableConfigValue(this.tableId, "showFilters");
    this.state = {
      apiError: "",
      dialogApiError: "",
      displayFilter: showFilters ? "initial" : "none",
      showFilters,
      showUpdatePackageModal: false,
      showDeletePackageModal: false,
      packageToDeleteOrUpdate: ""
    };

    this.handleUploadFile = this.handleUploadFile.bind(this);
    this.handleUpdatePackage = this.handleUpdatePackage.bind(this);
    this.handleDeletePackage = this.handleDeletePackage.bind(this);
    this.onDelete = this.onDelete.bind(this);
    this.onUpload = this.onUpload.bind(this);
  }

  async handleUploadFile(packages) {
    if (!this.props.softwareCatalog) return [];
    try {
      let updatedCatalog;
      for (const idx in packages) {
        try {
          updatedCatalog = await CamplaCoreService.uploadSoftwareCatalogPackage(
            this.props.softwareCatalog._id,
            packages[idx]
          );
          packages[idx]["status"] = 1;
        } catch (err) {
          packages[idx]["status"] = 2;
          this.setState({
            dialogApiError: APIErrorHelper.getError(
              err,
              () => this.setState({ dialogApiError: "" }),
              {
                PRECONDITION_FAILED:
                  "SingleSoftwareCatalog.PackagesTab.APIError.PreconditionFailed",
                NOT_FOUND: "SingleSoftwareCatalog.PackagesTab.APIError.NotFound"
              },
              this.props.t
            )
          });
        }
      }
      this.props.onUpdatePackages(updatedCatalog.packages);
    } catch (err) {
      this.setState({
        dialogApiError: APIErrorHelper.getError(
          err,
          () => this.setState({ dialogApiError: "" }),
          {
            PRECONDITION_FAILED:
              "SingleSoftwareCatalog.PackagesTab.APIError.PreconditionFailed",
            NOT_FOUND: "SingleSoftwareCatalog.PackagesTab.APIError.NotFound"
          },
          this.props.t
        )
      });
    }
    return packages;
  }

  async handleUpdatePackage(packages) {
    if (!this.props.softwareCatalog || packages.length === 0) return [];
    try {
      let updatedCatalog = undefined;
      const newPackage = packages[0];
      try {
        updatedCatalog = await CamplaCoreService.updateSoftwareCatalogPackage(
          this.props.softwareCatalog._id,
          this.state.packageToDeleteOrUpdate.id,
          packages[0]
        );
        newPackage["status"] = 1;
      } catch (err) {
        newPackage["status"] = 2;
        this.setState({
          dialogApiError: APIErrorHelper.getError(
            err,
            () => this.setState({ dialogApiError: "" }),
            {
              PRECONDITION_FAILED:
                "SingleSoftwareCatalog.PackagesTab.APIError.PreconditionFailed",
              NOT_FOUND: "SingleSoftwareCatalog.PackagesTab.APIError.NotFound"
            },
            this.props.t
          )
        });
      }
      if (updatedCatalog) {
        this.props.onUpdatePackages([...updatedCatalog.packages]);
      }
    } catch (err) {
      this.setState({
        dialogApiError: APIErrorHelper.getError(
          err,
          () => this.setState({ dialogApiError: "" }),
          {
            PRECONDITION_FAILED:
              "SingleSoftwareCatalog.PackagesTab.APIError.PreconditionFailed",
            NOT_FOUND: "SingleSoftwareCatalog.PackagesTab.APIError.NotFound"
          },
          this.props.t
        )
      });
    }
    return packages[0];
  }

  async handleDeletePackage() {
    try {
      await CamplaCoreService.deleteSoftwareCatalogPackage(
        this.props.softwareCatalog._id,
        this.state.packageToDeleteOrUpdate.id
      );
      const packages = this.props.softwareCatalog.packages.filter(
        p => p.id !== this.state.packageToDeleteOrUpdate.id
      );
      this.props.onUpdatePackages(packages);
      this.setState({
        showDeletePackageModal: false
      });
    } catch (err) {
      this.setState({
        dialogApiError: APIErrorHelper.getError(
          err,
          () => this.setState({ dialogApiError: "" }),
          {
            PRECONDITION_FAILED:
              "SingleExamination.ExaminationFilesTab.APIError.PreconditionFailed",
            NOT_FOUND: "SingleExamination.ExaminationFilesTab.APIError.NotFound"
          },
          this.props.t
        )
      });
    }
  }

  onDelete(pckge) {
    this.setState({
      showDeletePackageModal: true,
      packageToDeleteOrUpdate: pckge
    });
  }

  onUpload(pckge) {
    this.setState({
      showUpdatePackageModal: true,
      packageToDeleteOrUpdate: pckge
    });
  }

  render() {
    const { t } = this.props;
    const columns = [
      {
        dataField: "name",
        text: t("SingleSoftwareCatalog.PackagesTab.ColumnName"),
        sort: true,
        filter: textFilter({
          placeholder: t(
            "SingleSoftwareCatalog.PackagesTab.FilterNamePlaceholder"
          ),
          style: { display: this.state.displayFilter }
        })
      },
      {
        dataField: "version",
        text: t("SingleSoftwareCatalog.PackagesTab.ColumnVersion"),
        sort: false
      },
      {
        dataField: "actions",
        text: "",
        headerFormatter: () => (
          <ButtonGroup
            toggle
            style={{ float: "right", marginRight: "-12px" }}
          >
            <ToggleButton
              type="checkbox"
              value={1}
              className="btn-green btn-sm"
              checked={this.state.showFilters}
              onChange={e => {
                this.setState({
                  showFilters: e.currentTarget.checked,
                  displayFilter: e.currentTarget.checked ? "initial" : "none"
                });
                StorageService.setTableConfigValue(this.tableId, "showFilters", e.currentTarget.checked);
              }}
            >
              <FontAwesomeIcon icon={faFilter} />
            </ToggleButton>
          </ButtonGroup>
        ),
        headerClasses: "actionHeader",
        isDummyField: true,
        csvExport: false,
        formatter: (cell, row) => (
          <PackagesActionCell
            onUpload={() => this.onUpload(row)}
            onDelete={() => this.onDelete(row)}
          />
        )
      }
    ];

    return (
      <div>
        <DeletePackageDialog
          show={this.state.showDeletePackageModal}
          dialogApiError={this.state.dialogApiError}
          name={this.state.packageToDeleteOrUpdate.name}
          onHide={() =>
            this.setState({
              showDeletePackageModal: false
            })
          }
          onSubmit={this.handleDeletePackage}
        />
        <UploadFileDialog
          show={this.state.showUploadFileModal}
          dialogApiError={this.state.dialogApiError}
          onHide={() => this.setState({ showUploadFileModal: false })}
          onSubmit={this.handleUploadFile}
          title={t("SingleSoftwareCatalog.PackagesTab.UploadModal.Title")}
          body={t(
            "SingleSoftwareCatalog.PackagesTab.UploadModal.DragNDropBody"
          )}
          filesHeading={t(
            "SingleSoftwareCatalog.PackagesTab.UploadModal.Files"
          )}
          noFilesPlaceholder={t(
            "SingleSoftwareCatalog.PackagesTab.UploadModal.NoFilesUploaded"
          )}
        />
        <UploadFileDialog
          show={this.state.showUpdatePackageModal}
          dialogApiError={this.state.dialogApiError}
          onHide={() => this.setState({ showUpdatePackageModal: false })}
          onSubmit={this.handleUpdatePackage}
          multiple={false}
          title={t(
            "SingleSoftwareCatalog.PackagesTab.UpdatePackageModal.Title"
          )}
          body={t(
            "SingleSoftwareCatalog.PackagesTab.UpdatePackageModal.DragNDropBody"
          )}
          filesHeading={t(
            "SingleSoftwareCatalog.PackagesTab.UpdatePackageModal.Files"
          )}
          noFilesPlaceholder={t(
            "SingleSoftwareCatalog.PackagesTab.UpdatePackageModal.NoFilesUploaded"
          )}
        />
        <Container className="pl-0 pr-0">
          {this.state.apiError ? (
            <Row>
              <Col>{this.state.apiError}</Col>
            </Row>
          ) : (
            ""
          )}
          <Row className="mt-3">
            <Col>
              <h4>{t("SingleSoftwareCatalog.PackagesTab.Title")}</h4>
            </Col>
            <Col>
              <Button
                className="btn btn-green"
                style={{ float: "right" }}
                onClick={() => this.setState({ showUploadFileModal: true })}
              >
                <FontAwesomeIcon icon={faUpload} />
              </Button>
            </Col>
          </Row>
          <Row className="mt-3">
            <Col>
              <PaginationTable
                data={this.props.softwareCatalog.packages}
                sizePerPage={10}
                paginationSize={3}
                columns={columns}
                keyField="id"
                id={this.tableId}
              />
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

export default withTranslation()(PackagesTab);
